import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TempUser } from '@org/interfaces';
import { AuthService, GmAssignmentService, SysNotifyService, TempUserService, TenantService, UserService } from '@org/shared-services';
import { ConfirmationModalTWComponent } from '../confirmation-dialog/confirmation-modal-tw/confirmation-modal-tw.component';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { provideNgxMask, NgxMaskPipe } from 'ngx-mask';

@Component({
    selector: 'lib-vendor-approval',
    imports: [CommonModule, ConfirmationModalTWComponent, FontAwesomeModule, NgxMaskPipe],
    providers: [provideNgxMask()],
    templateUrl: './vendor-approval.component.html',
    styleUrl: './vendor-approval.component.scss'
})
export class VendorApprovalComponent {
  displayedColumns: string[] = [
    'vendorName',
    'contactName',
    'emailAddress',
    'phoneNumber',
    'servicesOffered',
    'createdAt',
    'actions'
  ];

  pendingVendors: TempUser[] = [];
  tenantId: string = '';
  showConfirmModal = false;
  selectedVendor: TempUser | null = null;
  modalType: 'approve' | 'reject' = 'approve';

  selectedVendorForMobile: TempUser | null = null; 
  faEye = faEye;

  user!: any;
  currentTenant: any = null;


  constructor(
    private tempUserService: TempUserService, 
    private tenantService: TenantService, 
    private authService: AuthService,
    private userService: UserService,
    private sysNotifyService: SysNotifyService,
    private gmAssignmentService: GmAssignmentService
  ) {}

  ngOnInit() {
    this.user = this.authService.currentUserValue;
    if (this.user && this.user.roles.includes('gm')) {
      this.gmAssignmentService.getCurrentTenant().subscribe((res: any) => {
        this.currentTenant = res.data.tenant;
        this.loadPendingVendors();
      });
    } else {
      this.currentTenant = this.user?.tenant;
      this.loadPendingVendors();
    }
   
   
  }

  openConfirmModal(vendor: TempUser, type: 'approve' | 'reject') { 
    this.selectedVendor = vendor;
    this.modalType = type;
    this.showConfirmModal = true;
  }

  private loadPendingVendors() {
    const tenantId = this.getTenantContext();
    this.tempUserService.getPendingVendors(tenantId).subscribe((vendors: TempUser[]) => {
      this.pendingVendors = vendors;
    });
  }

  handleConfirm() {
    if (!this.selectedVendor) return;

    if (this.modalType === 'approve') {
      this.approveVendor(this.selectedVendor);
    } else {
      this.rejectVendor(this.selectedVendor);
    }
    
    this.closeModal();
  }

  closeModal() {
    this.showConfirmModal = false;
    this.selectedVendor = null;
  }

  approveVendor(vendor: TempUser) {
    // Implement approval logic
    this.tempUserService.approveVendor(vendor._id).subscribe((vendor: TempUser) => {
      this.sysNotifyService.showSuccess('Vendor approved successfully');
      this.loadPendingVendors();
    });
  }

  rejectVendor(vendor: TempUser) {
    // Implement rejection logic
    this.tempUserService.rejectVendor(vendor._id).subscribe(() => {
      this.sysNotifyService.showSuccess('Vendor rejected successfully');
      this.loadPendingVendors();
    });
  }

  openMobileDetail(vendor: TempUser) {
    this.selectedVendorForMobile = vendor;
  }

  closeMobileDetail() {
    this.selectedVendorForMobile = null;
  }

  private getTenantContext(): string {
    if (this.user && this.user.roles && this.user.roles.includes('gm')) {
      return this.currentTenant;
    }
    return this.user?.tenant;
  }
}
